import { useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from 'redux/toolkit/hooks'
import { getMessage, MstoreState, reset } from 'redux/features/mstore/mstoreSlice'
import { getAccountPermissions, SettingsState } from 'redux/features/settings/settingsSlice'
import useUserRights, { UserRights } from 'components/libs/userRights/useUserRights'

export interface State {
  accountPermissions: SettingsState['accountPermissions']
  message: MstoreState['message']
}

export type MessageDetailLogic = [State]

export const useMessageDetailLogic = (): MessageDetailLogic => {
  const { messageId, domainId } = useParams<{ messageId: string; domainId: string }>()
  const dispatch = useAppDispatch()
  const { accountPermissions, message, userId } = useAppSelector(_store => ({
    accountPermissions: _store.settings.accountPermissions,
    message: _store.mstore.message,
    userId: _store.auth.accessTokenObject?.userId
  }))
  const { userHasRight } = useUserRights()

  useEffect(() => {
    dispatch(reset())
    dispatch(getAccountPermissions())
  }, [dispatch])

  useEffect(() => {
    if (messageId && domainId && accountPermissions) {
      dispatch(
        getMessage({
          messageId,
          showImages: 0,
          headersOnly: 0,
          domainId,
          userId: userHasRight(UserRights.SKIP_TO_SEND_USER_ID_FOR_MESSAGE_ACTIONS) ? undefined : userId
        })
      )
    }
  }, [dispatch, messageId, domainId, accountPermissions, userHasRight, userId])

  return useMemo(
    () => [
      {
        accountPermissions,
        message
      }
    ],
    [accountPermissions, message]
  )
}
